module.exports = __webpack_public_path__ + "fonts/NouvelR-Book.43d01f9a.ttf";